// extracted by mini-css-extract-plugin
export default {"content":"xrTCCraw","_premium":"LqFXNWTj","expert":"m_bErHnJ","mobile":"mobile","title":"Cqvs5c42","_capitalizeFirstLetter":"NIJQzuel","subtitle":"PC6P06C7"};